
 <div class="col-md-12">
 <app-common-search-view [form]="form" header="Orsaker" (createReport)="createReport($event)" [showSpinner]="showSpinner" (clearReport)="clear()"></app-common-search-view>
</div>
<br>
  <div *ngIf="result?.length > 0" class="me-4 ms-4">
    <p-menubar [model]="items">
      <div style="margin-top:5px;margin-right:10px;">
        Resultat: {{rowcount}} institutioner
    </div>
    </p-menubar>

    <div *ngFor="let y of form.get('selectedYears').value;index as ii;" class="me-2 ms-2">
    <b *ngIf="result[ii]?.length > 0">{{y}}</b>
      <table *ngIf="!total && result[ii]?.length > 0" class="table">
      <tr>
        <th>#</th>
        <th>Id</th>
        <th>Förnamn</th>
        <th>Efternamn</th>
        <th>Primärinstitution</th>
        <th>Startdatum</th>
        <th>Slutdatum</th>
        <th>Orsak</th>
      </tr>

        <tr *ngFor="let r of result[ii];index as i;">
        <td>{{i + 1}}</td>
        <td> <a [routerLink]="['/memberform/id/', r?.memberId]">{{r?.memberId}}</a></td>
        <td>{{r?.givenName}}</td>
        <td>{{r?.familyName}}</td>
        <td>{{r?.institution.shortName}} {{r?.institution.name}}</td>
        <td>{{r?.startDate | date: 'yyyy-MM-dd'}}</td>
        <td>{{r?.endDate | date: 'yyyy-MM-dd'}}</td>
        <td>{{r?.cause?.description}}</td>
      </tr>

    </table>

    <table *ngIf="total" class="table">
      <tr>
        <th>#</th>
        <th>Kortnamn</th>
        <th>Institution</th>
        <th>Antal</th>
        <th>Orsak</th>
      </tr>

        <tr *ngFor="let r of result[ii];index as i;">
        <td>{{i + 1}}</td>
        <td>{{r?.institution.shortName}}</td>
        <td> <a [routerLink]="['/institutions/id/', r?.institution.institutionId]">{{r?.institution.name}}</a></td>
        <td>{{r?.attendanceCount}}</td>
        <td>{{r?.cause?.description}}</td>
      </tr>

    </table>
  </div>
  </div>
<br><br>
